<form [formGroup]="personalForm">
    <div class="personal-form-group row">
        <div class="d-flex justify-content-between group-form-title mt-3 mb-2">
            <p #personalInfoForm class="mat-caption">PERSONAL INFORMATION</p>
            @if (this.initialFormData) {
                <button class="personal-reset-data" mat-button type="submit" (click)="resetData()" color="primary">
                    RESET DATA
                </button>
            }
        </div>
        <mat-form-field class="col-12">
            <mat-label for="firstName">First name</mat-label>
            <input matInput id="firstName" type="text" formControlName="firstName" placeholder="First name" />
            <mat-error>
                <app-field-error [field]="'firstName'" [messageList]="formErrors['firstName']"></app-field-error>
            </mat-error>
        </mat-form-field>
        <mat-form-field class="col-12">
            <mat-label for="lastName">Last name</mat-label>
            <input matInput id="lastName" type="text" formControlName="lastName" placeholder="Last name" />
            <mat-error>
                <app-field-error [field]="'lastName'" [messageList]="formErrors['lastName']"></app-field-error>
            </mat-error>
        </mat-form-field>
        <div class="col-12">
            <lib-phone-input
                [isFormEnabled]="true"
                [blackListCountryCodes]="blackListedCountryCodes"
                [countryCode]="initialCountryCode"
                [phone]="initialPhone"
            ></lib-phone-input>
        </div>
        <mat-form-field class="col-12">
            <mat-label for="email">Email</mat-label>
            <input matInput id="email" type="text" formControlName="email" placeholder="Email" />
            <mat-error>
                <app-field-error [field]="'email'" [messageList]="formErrors['email']"></app-field-error>
            </mat-error>
        </mat-form-field>
    </div>
</form>
